import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { routes } from "./routes"
import { getStaffUserDefaultRoute } from "utils/permissionRedirect"
import { usePermissions } from "hooks/usePermissions"
import { MODULES, ACTIONS } from "utils/permissions"
import { isFeatureEnabled } from "config/features"

const PermissionBasedRedirect = () => {
  const navigate = useNavigate()
  const { role } = useSelector((store) => store.user)
  const { hasPermission, permissions } = usePermissions()

  useEffect(() => {
    if (!role) {
      return
    }

    const isDashboardAvailable = isFeatureEnabled("AI_DASHBOARD") && hasPermission(MODULES.ACCOUNTING, ACTIONS.FULL_ACCESS)

    if (isDashboardAvailable) {
      navigate(routes.guideAIDashboardPath(), { replace: true })
      return
    }

    if (role === "staff_user") {
      if (!permissions || Object.keys(permissions).length === 0) {
        return
      }
      const defaultRoute = getStaffUserDefaultRoute(permissions)
      navigate(defaultRoute, { replace: true })
      return
    }

    navigate(routes.proCalendarPath(), { replace: true })
  }, [role, permissions, hasPermission, navigate])

  return null
}

export default PermissionBasedRedirect
